type sortableItem = {
  sortOrder: number,
}

export const sortBySortOrder = (a: sortableItem, b: sortableItem) => {
  if (a.sortOrder < b.sortOrder) {
    return -1
  }
  if (a.sortOrder > b.sortOrder) {
    return 1
  }
  return 0
}
